$(function(){
	(function fade($ele) {
		$ele.fadeIn(1000).delay(7000).fadeOut(1000, function() {
			var $next = $(this).next('.quote');
			fade($next.length > 0 ? $next : $(this).parent().children().first());
		});
	})($('.quoteLoop > .quote').first());
	
	/** Smooth Scrolling **/
	(function navSmoothScrolling(){
		const navLinks = document.querySelectorAll( '.nav-link' );
		for ( let n in navLinks ) {
			if ( navLinks.hasOwnProperty( n ) ) {
				navLinks[ n ].addEventListener( 'click', e => {
					e.preventDefault( );
					document.querySelector( navLinks[ n ].hash ).scrollIntoView( { block: "start", behavior: "smooth" });
				} );
			}
		}
	})();
	
	/** ScrollSpy **/
	(function scrollSpy( ) {
		const sections = document.querySelectorAll( '.section' );
		const navBar   = document.querySelector( '#navbar' );
		window.onscroll = () => {
			let scrollPos = document.documentElement.scrollTop || document.body.scrollTop;
			if ( sections[ 0 ].closest('section').offsetTop === scrollPos ) {
				navBar.classList.remove( 'bg-black' );
				navBar.classList.add( 'bg-transparent' );
			} else {
				navBar.classList.remove( 'bg-transparent' );
				navBar.classList.add( 'bg-black' );
			}
			scrollPos += window.innerHeight / 2;
			for ( let s in sections )
				if ( sections.hasOwnProperty( s ) && sections[s].closest('section').offsetTop <= scrollPos ) {
					const id = sections[ s ].id;
					
					if(navBar.querySelector( '.active' )){
						navBar.querySelector( '.active' ).classList.remove( 'active' );
					}
					
					if(navBar.querySelector( `a[href*=${ id }]` )){
						navBar.querySelector( `a[href*=${ id }]` ).classList.add( 'active' );
					}
				}
			}
	})( );
});

$(document).on("click", '[data-toggle="lightbox"]', function(event){
	event.preventDefault();
	$(this).ekkoLightbox();
});